const Loader = () => {
  return (
    <div className="loader">
      <div className="lds-ripple">
        <div></div>
        <div></div>
      </div>
      Patience is the key to victory...
    </div>
  );
};

export default Loader;
